import React from 'react';
import { UserRound } from 'lucide-react';

const PageHeading = ({ icon, title, subtitle, className = '' }) => {
  let username = '';

  try {
    username = JSON.parse(localStorage.getItem('auth') || '{}')?.username || '';
  } catch {
    username = '';
  }

  return (
    <div className={`relative mb-6 flex flex-col items-center gap-2 text-center ${className}`}>
      {username && (
        <span className="inline-flex items-center gap-2 self-end rounded-full border border-gray-200 bg-white/90 px-3 py-1.5 text-xs font-semibold text-gray-700 shadow-sm dark:border-gray-600 dark:bg-gray-800/90 dark:text-gray-100 sm:absolute sm:right-0 sm:top-0">
          <UserRound size={15} aria-hidden="true" />
          {username}
        </span>
      )}
      <div className="rounded-full bg-blue-100 p-3 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200">{icon}</div>
      <h1 className="text-3xl font-extrabold">{title}</h1>
      {subtitle && <p className="max-w-2xl text-sm text-gray-600 dark:text-gray-300">{subtitle}</p>}
    </div>
  );
};

export default PageHeading;
